"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.hoverComponent = exports.dispatchAppInit = exports.clickComponent = exports.WINDOW_MESSAGE_RECIEVED = exports.UPDATE_LOCALS = exports.LAYOUT_UPDATE_PROP = exports.LAYOUT_UPDATE_OVERRIDE = exports.LAYOUT_RELOADED = exports.LAYOUT_RELOAD = exports.EDITION_UPDATE = exports.COMPONENT_SEND_OFFSET = exports.COMPONENT_OFFSET_POSTED = exports.COMPONENT_HOVER_RECEIVED = exports.COMPONENT_HOVER_POSTED = exports.COMPONENT_HOVER = exports.COMPONENT_CLICK_RECEIVED = exports.COMPONENT_CLICK_POSTED = exports.COMPONENT_CLICK = exports.APP_INIT = void 0;
const APP_INIT = exports.APP_INIT = 'APP_INIT';
const COMPONENT_CLICK = exports.COMPONENT_CLICK = 'COMPONENT_CLICK';
const COMPONENT_CLICK_POSTED = exports.COMPONENT_CLICK_POSTED = 'COMPONENT_CLICK_POSTED';
const COMPONENT_CLICK_RECEIVED = exports.COMPONENT_CLICK_RECEIVED = 'COMPONENT_CLICK_RECEIVED';
const COMPONENT_HOVER = exports.COMPONENT_HOVER = 'COMPONENT_HOVER';
const COMPONENT_HOVER_POSTED = exports.COMPONENT_HOVER_POSTED = 'COMPONENT_HOVER_POSTED';
const COMPONENT_HOVER_RECEIVED = exports.COMPONENT_HOVER_RECEIVED = 'COMPONENT_HOVER_RECEIVED';
const COMPONENT_SEND_OFFSET = exports.COMPONENT_SEND_OFFSET = 'COMPONENT_SEND_OFFSET';
const COMPONENT_OFFSET_POSTED = exports.COMPONENT_OFFSET_POSTED = 'COMPONENT_OFFSET_POSTED';
const LAYOUT_RELOAD = exports.LAYOUT_RELOAD = 'LAYOUT_RELOAD';
const LAYOUT_RELOADED = exports.LAYOUT_RELOADED = 'LAYOUT_RELOADED';
const LAYOUT_UPDATE_PROP = exports.LAYOUT_UPDATE_PROP = 'LAYOUT_UPDATE_PROP';
const LAYOUT_UPDATE_OVERRIDE = exports.LAYOUT_UPDATE_OVERRIDE = 'LAYOUT_UPDATE_OVERRIDE';
const EDITION_UPDATE = exports.EDITION_UPDATE = 'EDITION_UPDATE';
const UPDATE_LOCALS = exports.UPDATE_LOCALS = 'UPDATE_LOCALS';
const WINDOW_MESSAGE_RECIEVED = exports.WINDOW_MESSAGE_RECIEVED = 'WINDOW_MESSAGE_RECIEVED';
const dispatchAppInit = () => ({
  type: APP_INIT
});
exports.dispatchAppInit = dispatchAppInit;
const clickComponent = value => ({
  type: COMPONENT_CLICK,
  value
});
exports.clickComponent = clickComponent;
const hoverComponent = value => ({
  type: COMPONENT_HOVER,
  value
});
exports.hoverComponent = hoverComponent;